export default __webpack_public_path__ + "static/media/somethingWentWrong4.d547694b.png";